import { useEffect } from "react";

const upsertMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const useSEO = ({ title, description, path = "" }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            upsertMeta("name", "description", description);
            upsertMeta("property", "og:description", description);
        }
        upsertMeta("property", "og:title", title || "Vantera");
        upsertMeta("property", "og:url", `https://vantera.preview.emergentagent.com${path}`);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `https://vantera.preview.emergentagent.com${path}`);
    }, [title, description, path]);
    return null;
};